import { useQueryClient } from "@tanstack/react-query";
import { LogOut, ShieldAlert } from "lucide-react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { StatusCard } from "@/features/auth/components/status-card";
import { VerificationShell } from "@/features/auth/components/verification-shell";
import { useAuth } from "@/store/use-auth";

interface AccountUnavailableProps {
	title?: string;
	description?: string;
}

export function AccountUnavailable({
	title = "Nenhuma conta disponível",
	description = "Não encontramos uma conta ativa para o usuário conectado. Saia e entre novamente com outra conta.",
}: AccountUnavailableProps) {
	const navigate = useNavigate();
	const signOut = useAuth((state) => state.signOut);
	const queryClient = useQueryClient();

	function handleSignOut() {
		signOut();
		queryClient.clear();
		navigate("/login", { replace: true });
	}

	return (
		<VerificationShell>
			<StatusCard
				tone="danger"
				icon={<ShieldAlert />}
				title={title}
				description={description}
				action={
					<Button
						type="button"
						className="status-card__action"
						onClick={handleSignOut}
					>
						<LogOut />
						Sair da conta
					</Button>
				}
			/>
		</VerificationShell>
	);
}
